import Box from "@mui/material/Box";
import React from "react";

import { formKey } from "../../../hooks/useQuoteBoxStructure";
import { NumberedSectionTitle } from "../OpenBoxQuotes/FormFields";
import { useStyles } from "../styles";
import AccessoriesLocks from "./AccessoriesLocks";
import AccessoriesSafety from "./AccessoriesSafety";
import AccessoriesTying from "./AccessoriesTying";

const Accessories = () => {
  const styles = useStyles();

  return (
    <Box className={styles.inputCard}>
      <NumberedSectionTitle
        number={3}
        titleKey={formKey("SECTIONS.EQUIPMENT")}
      />
      <AccessoriesTying />
      <AccessoriesSafety />
      <AccessoriesLocks />
    </Box>
  );
};

export default Accessories;
